import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Box, Grid, Card, CardActionArea, Typography, Stack } from "@mui/material";
import Icon from "@mui/material/Icon";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import bgHome from "assets/images/webReport_landingPage.png";
import { useTheme } from "@mui/material/styles";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";

export default function Home() {
    const navigate = useNavigate();
    const theme = useTheme();

    const right = useSelector(state => state.common.rights);
    const groupId = useSelector(state => state.common.groupId);
    const verifiedEntityLevel = useSelector(state => state.common.verifiedEntityLevel);

    const roleMeta = {
        "3": {
            label: "Firma Kullanıcısı",
            helperText:
                "Numara Sorgulama ekranını her zaman kullanabilirsiniz. Yetkiniz kapsamında Gönderim ve Alfanümerik raporlarını görüntüleyebilir, ayrıca firma bazlı analizler için Firma Raporu ekranlarına erişebilirsiniz.",
        },
        "0": {
            label: "Standart Kullanıcı",
            helperText:
                "Numara Sorgulama ekranını her zaman kullanabilirsiniz. Gönderim ve Alfanümerik raporlarda, yalnızca size tanımlı kullanıcılar kapsamında sorgulama ve görüntüleme yapabilirsiniz.",
        },
        "4": {
            label: "Codec Üst Yetkilisi",
            helperText:
                "Numara Sorgulama ekranını her zaman kullanabilirsiniz. Gönderim ve Alfanümerik raporların yanı sıra firma bazlı raporlara ve Günlük Rapor ekranına da erişebilirsiniz.",
        },
        "2": {
            label: "Codec Yetkilisi",
            helperText:
                "Numara Sorgulama ekranını her zaman kullanabilirsiniz. Gönderim ve Alfanümerik raporlarını görüntüleyebilir, ek olarak Günlük Rapor ekranına da erişebilirsiniz.",
        },
        "5": {
            label: "Numara Sorgulama Kullanıcısı",
            helperText:
                "Bu rolde yalnızca Numara Sorgulama ekranını kullanabilirsiniz. Diğer rapor ekranları için erişiminiz bulunmamaktadır.",
        },
    };

    const currentRole = roleMeta[right] ?? {
        label: "Bilinmeyen Yetki",
        helperText:
            "Yetki tanımı bulunamadı. Lütfen sistem yöneticinizle iletişime geçin.",
    };


    const buildQuickLinks = () => {
        const links = [];

        // Gönderim → Right != 5
        if (right !== "5") {
            links.push({
                title: "Gönderim Raporu",
                icon: "send",
                to: "/GonderimRaporu",
            });
        }

        // Numara Sorgulama → her zaman
        links.push({
            title: "Numara Sorgulama",
            icon: "manage_search",
            to: "/NumaraSorgulama",
        });

        // Firma → GroupId > 0 && Right IN (2,3,4)
        if (groupId > "0" && ["2", "3", "4"].includes(right)) {
            links.push({
                title: "Firma Raporu",
                icon: "apartment",
                to: "/FirmaRaporu",
            });
        }

        // Alfanümerik → GroupId > 0 && Right != 5
        if (groupId > "0" && right !== "5") {
            links.push({
                title: "Alfanumerik Raporu",
                icon: "summarize",
                to: "/AlfanumerikRaporu",
            });
        }

        // Günlük → Right IN (2,4)
        if (["2", "4"].includes(right)) {
            links.push({
                title: "Günlük Rapor",
                icon: "event_note",
                to: "/GunlukRapor",
            });
        }

        // Sorgular → her zaman
        links.push({
            title: "Sorgular",
            icon: "dashboard",
            to: "/Sorgular",
        });

        if (verifiedEntityLevel == "AccountMaster") {
            links.push({
                title: "Kullanıcı Yönetimi",
                icon: "account_box",
                to: "/KullaniciYonetimi",
            });
        }

        return links;
    };

    const allQuickLinks = buildQuickLinks();

    const topSx = {
        borderRadius: 3,
        p: { xs: 2, md: 3 },
        color: "#fff",

        backgroundImage: `
      linear-gradient(
        135deg,
        rgba(10,42,102,.88) 0%,
        rgba(11,98,182,.78) 45%,
        rgba(10,139,214,.68) 100%
      ),
      url(${bgHome})
    `,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
    };

    const bottomSx = {
        flex: 1,
        bgcolor: theme.palette.background.default,
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />


            <Box sx={topSx}>
                <Box sx={{ textAlign: "center", mb: 3 }}>
                    <Typography sx={{ fontWeight: 800, fontSize: { xs: 26, md: 44 } }}>
                        Codec WebRapor&apos;a Hoş Geldiniz
                    </Typography>
                    <Typography sx={{ opacity: 0.9, mt: 0.5, fontSize: { xs: 13, md: 18 } }}>
                        Raporlarınızı kolayca yönetin ve analiz edin
                    </Typography>
                </Box>

                <Box sx={{ maxWidth: 980, mx: "auto", mb: 3 }}>
                    <Card
                        sx={{
                            borderRadius: 3,
                            p: 2,
                            bgcolor: "rgba(255,255,255,.92)",
                            backdropFilter: "blur(6px)",
                            boxShadow: "0 10px 26px rgba(0,0,0,.12)",
                        }}
                    >
                        <Stack direction="row" spacing={1.5} alignItems="flex-start">
                            <Box
                                sx={{
                                    width: 38,
                                    height: 38,
                                    borderRadius: 2,
                                    display: "grid",
                                    placeItems: "center",
                                    bgcolor: "rgba(11,98,182,.12)",
                                    color: "#0B62B6",
                                    flex: "0 0 auto",
                                }}
                            >
                                <Icon>info</Icon>
                            </Box>

                            <Box sx={{ minWidth: 0 }}>
                                <Typography sx={{ fontWeight: 800, fontSize: 14, color: "rgba(0,0,0,.82)" }}>
                                    Yetkiniz: {currentRole.label}
                                </Typography>
                                <Typography sx={{ mt: 0.5, fontSize: 13, color: "rgba(0,0,0,.70)" }}>
                                    {currentRole.helperText}
                                </Typography>
                            </Box>
                        </Stack>
                    </Card>
                </Box>

                <Grid container spacing={3}>
                    {allQuickLinks.map((x) => (
                        <Grid item xs={12} sm={6} md={4} key={x.to}>
                            <Card
                                sx={{
                                    borderRadius: 3,
                                    overflow: "hidden",
                                    boxShadow: "0 10px 26px rgba(0,0,0,.22)",
                                    transition: "all .25s ease",
                                    "&:hover": {
                                        transform: "translateY(-4px)",
                                        boxShadow: "0 18px 36px rgba(0,0,0,.28)",
                                    },
                                }}
                            >
                                <CardActionArea onClick={() => navigate(x.to)} sx={{ p: 2, height: 96 }}>
                                    <Stack direction="row" spacing={1.5} alignItems="center">
                                        <Box
                                            sx={{
                                                width: 44,
                                                height: 44,
                                                borderRadius: 2,
                                                display: "grid",
                                                placeItems: "center",
                                                bgcolor: "rgba(11,98,182,.10)",
                                                color: "#0B62B6",
                                            }}
                                        >
                                            <Icon>{x.icon}</Icon>
                                        </Box>

                                        <Typography sx={{ fontWeight: 700, fontSize: 14, color: "rgba(0,0,0,.75)" }}>
                                            {x.title}
                                        </Typography>
                                    </Stack>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
            <Box sx={bottomSx} />
        </DashboardLayout>
    );
}
